const roles = {
	INDIVIDUAL: "INDIVIDUAL",
	PROFESSIONAL: "PROFESSIONAL",
};

export default roles;
